import { SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { downloadFileFromDataString } from "../../../utils/download";
import { useRequest } from "../../../utils/request";

export const useGetAccountIndemnityAgreementFileUrl = ({
	accountId,
	indemnityAgreementId,
	asDownload,
}: {
	accountId: SuretyAccountId;
	indemnityAgreementId?: SuretyIndemnityAgreementId;
	asDownload?: boolean;
}) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: indemnityAgreementId
			? [
					"accounts",
					accountId,
					"indemnity-agreements",
					indemnityAgreementId,
					"url",
					{ download: asDownload },
				]
			: ["accounts", accountId, "indemnity-agreements", "url", { download: asDownload }],
		queryFn: async () => {
			if (indemnityAgreementId) {
				return await get(
					`/v2/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/url?download=${asDownload ?? false}`,
					undefined,
					"text",
				);
			}
			return await get(
				`/v2/surety/accounts/${accountId}/indemnity-agreements/url?download=${asDownload ?? false}`,
				undefined,
				"text",
			);
		},
		retry: false,
		staleTime: 60000,
		enabled: false,
	});

	const downloadIndemnityAgreement = () => {
		refetch().then(({ data }) => {
			if (data) {
				downloadFileFromDataString(data);
			}
		});
	};

	return {
		getIndemnityAgreementFileUrl: refetch,
		downloadIndemnityAgreement,
		indemnityAgreementFileUrl: data,
		indemnityAgreementFileUrlError: error,
		indemnityAgreementFileUrlLoading: isLoading,
	};
};
